export default __webpack_public_path__ + "static/eco-sustainability-reusable-badge-46cc3c1538205fc3dac71305f2b7ca8e.svg";